import React from "react";
import { Box, Typography } from "@mui/material";

import SkillLevelProgressRow from "./Graphs/SkillLevelProgressRow";

const DEFAULT_LEVEL = "1";
const DEFAULT_PROGRESS = 0.1;

/**
 * topic.skills is an array of objects like:
 *   { id: "pc", name: "Punctuation" }
 *
 * analyticsSkills is a map like:
 *   { pc: { band: "2-3", ... }, cc: { band: "1", ... } }
 */
const SubTopicGraphCard = ({ topic, section, analyticsSkills = {} }) => {
  return (
    <Box sx={{ px: 1, pt: 0.5, mb: 3 }}>
      {/* Sub-topic header */}
      <Typography
        variant="subtitle1"
        fontWeight={800}
        sx={{ mb: 1.25, lineHeight: 1.2 }}
      >
        {topic.name}
      </Typography>

      {/* Column labels row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 2,
          mb: 1.25,
        }}
      >
        <Box sx={{ width: 180 }}>
          <Typography variant="caption" fontWeight={700} color="text.secondary">
            Skill
          </Typography>
        </Box>

        <Box sx={{ flex: 1, display: "flex" }}>
          {["Foundations", "Developing", "Intermediate", "Advanced", "Proficient"].map(
            (lbl) => (
              <Box key={lbl} sx={{ flex: 1, textAlign: "center" }}>
                <Typography
                  variant="caption"
                  fontWeight={700}
                  color="text.secondary"
                  sx={{ lineHeight: 1 }}
                >
                  {lbl}
                </Typography>
              </Box>
            )
          )}
        </Box>
      </Box>

      {/* Skill rows */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        {topic.skills.map((skill) => {
          const skillCode = skill.code;
          const band = analyticsSkills?.[skillCode]?.band ?? DEFAULT_LEVEL;
          return (
            <SkillLevelProgressRow
              key={skillCode}
              topic={skill.name}
              currentLevel={band}
              progress={DEFAULT_PROGRESS}
              labelWidth={180}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default SubTopicGraphCard;
